<button sdLink class="catalog-btn" [ngClass]="{ 'is-active': isOpen$ | async }" (click)="toggleOpen()">
  <cx-icon type="CATALOG"></cx-icon>
  <span class="label">Каталог</span>
</button>
<nav *ngIf="isOpen$ | async" (clickOutside)="toggleOpen(false)">
  <div class="menu-columns" data-analytics="catalog_menu">
    <ul *ngFor="let parentNode of nodes$ | async">
      <ng-container *ngIf="{ childNodes: parentNode.items$ | async } as obs">
        <cx-spinner *ngIf="!obs.childNodes && loading$ | async"></cx-spinner>
        <li
          *ngFor="let childNode of obs.childNodes"
          [ngClass]="{
            'has-children': childNode.hasChildren,
            active: isInNodesList(childNode.nodeId),
          }"
          (mouseenter)="
            changeNodesListWithDebounce(
              childNode.nodeId,
              childNode.hasChildren ? parentNode.level + 1 : parentNode.level,
              childNode.hasChildren
            )
          "
        >
          <sd-generic-link [url]="childNode.url">
            {{ childNode.name }}
          </sd-generic-link>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
